const dev = {
  API_ENDPOINT_URL: 'https://dev-adani-interface.mjunction.in',
  API_IMAGE_BASE_URL : "https://dev-adani-dms.mjunction.in/"
};

const stag = {
  API_ENDPOINT_URL: 'https://uat-servicerewardsconnect.adani.com',
  API_IMAGE_BASE_URL : "https://uatadmin-rewardsconnect.adani.com/"
};

const prod = {
  API_ENDPOINT_URL: 'https://servicerewardsconnect.adani.com',
  API_IMAGE_BASE_URL : "https://admin-rewardsconnect.adani.com/"
};

const getEnv = () => {
  switch (process.env.REACT_APP_ENV) {
    case 'dev':
      return dev;
    case 'prod':
      return prod;
    case 'stag':
      return stag;
    default:
      return dev;
  }
};

// eslint-disable-next-line import/prefer-default-export
export const env = getEnv();